import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Drawer,
} from '@material-ui/core';
import { useLocation } from 'react-router-dom';

import Modal from '../../components/Modal/Modal';
import InfoImg from '../../assets/images/sportsbook/info.svg';

import { BsData, PlaceBetRequest } from '../../models/BsData';
import ExchOddBtn from '../ExchOddButton/ExchOddButton';
import { addExchangeBet } from '../../store';
import API from '../../api';
import { AxiosResponse } from 'axios';
import { useInterval } from '../../hooks/useInterval';
import { RootState } from '../../models/RootState';
import { UserBet } from '../../models/UserBet';
import MarketTermsCondi from '../../components/MarketTermsCondi/MarketTermsCondi';
import { IonIcon } from '@ionic/react';
import {
  subscribeWsForBinaryMarkets,
  connectToWS,
  unsubscribeWsforBinaryEvent,
} from '../../webSocket/webSocket';
import { BinaryEvent } from '../../models/BinaryEvent';
import './ExchBinaryEventsTable.scss';
import moment from 'moment';
import { DisabledBinaryEvents } from '../../util/stringUtil';
import { CloseOutlined } from '@material-ui/icons';

type OddsInfoMsg = {
  launch: boolean;
  oddsType?: string;
  eventTypeID: string;
};

type BinaryLimits = {
  betLimitsType: string;
  createdAt: string;
  createdBy: string;
  genId: string;
  id: string;
  lastUpdated: string;
  maxStake: number;
  minStake: number;
  refId: string;
};

type StoreProps = {
  addExchangeBet: (bet: PlaceBetRequest) => void;
  bets: PlaceBetRequest[];
  openBets: UserBet[];
  loggedIn: boolean;
  binaryOdds: BinaryEvent[];
  betFairWSConnected: boolean,
};

const BinaryEventsTable: React.FC<StoreProps> = (props) => {
  const { addExchangeBet, bets, openBets, loggedIn, binaryOdds, betFairWSConnected } = props;
  const [binaryEvents, setbinaryEvents] = useState<BinaryEvent[]>([]);
  const [betLimits, setBetLimits] = useState<BinaryLimits>(null);

  const [infoDilalog, setInfoDialog] = useState<OddsInfoMsg>({
    launch: false,
    oddsType: null,
    eventTypeID: null,
  });
  const location = useLocation();
  const disabledBinaryEvents = DisabledBinaryEvents();
  const tableFields = [
    {
      key: 'marketName',
      Label: '',
      className: 'market-name-cell-head',
      align: 'left',
    },
    {
      key: 'oddsNo',
      Label: 'No',
      className: 'odds-cell-head',
      align: 'center',
    },
    {
      key: 'oddsYes',
      Label: 'Yes',
      className: 'odds-cell-head',
      align: 'center',
    },
  ];

  const fetchData = async () => {
    // if (!sessionStorage.getItem('jwt_token')) {
    //   const response: AxiosResponse<BinaryEvent[]> = await API.get(
    //     '/binary/trading'
    //   );
    //   setbinaryEvents(response.data);
    // } else {
    const response: AxiosResponse<BinaryEvent[]> = await API.get(
      '/binary/trading',
      {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
      }
    );
    let binaryEvents = response.data.filter((r) => {
      return !disabledBinaryEvents.includes(r.RunnerName);
    });
    setbinaryEvents(binaryEvents);
    // }
  };

  const fetchBinaryLimits = async () => {
    const response: AxiosResponse<any> = await API.get(
      '/binary/get-binary-limits'
    );
    // console.log(response);
    setBetLimits(response.data);
  };

  useEffect(() => {
    if (loggedIn && binaryOdds.length > 0) {
      let binaryEvents = binaryOdds.filter((r) => {
        return !disabledBinaryEvents.includes(r.RunnerName);
      });
      setbinaryEvents(binaryEvents);
    }
  }, [binaryOdds]);

  useEffect(() => {
    if (!loggedIn) {
      unsubscribeWsforBinaryEvent();
    }
  }, [loggedIn]);

  // Update binary data for every 1 seconds.
  useEffect(() => {
    if (loggedIn) {
      subscribeWsForBinaryMarkets();
    }
  }, [betFairWSConnected, loggedIn]);

  const getDisplayName = (runnerName: string) => {
    // let name =
    //   runnerName.split(':').length > 1
    //     ? runnerName.split(':')[1]
    //     : runnerName.split(':')[0];
    // if (name.toLowerCase().includes('crudeoil')) return 'CRUDE OIL 10:30 PM';
    // else if (name.toLowerCase().includes('gold')) return 'GOLD 10:30 PM';
    // else if (name.toLowerCase().includes('silver')) return 'SILVER 10:30 PM';
    // else if (name.toLowerCase().includes('banknifty'))
    //   return 'BANK NIFTY 2:30 PM';
    // else if (name.toLowerCase().includes('nifty 50'))
    //   return 'NIFTY 50  2:30 PM';
    return runnerName;
  };

  const getRiskValue = (bCategory: BinaryEvent) => {
    let probableRunsList = [];
    const marketOpenBets = openBets.filter(
      (b) => b.outcomeDesc === bCategory.RunnerName
    );
    const marketBetslipBets = bets.filter(
      (b) => b.amount && b.outcomeId === bCategory.RunnerName
    );
    let maxRisk = 0;
    for (let oBet of marketOpenBets) {
      if (!probableRunsList.includes(oBet.sessionRuns)) {
        probableRunsList.push(oBet.sessionRuns);
      }
      if (!probableRunsList.includes(oBet.sessionRuns - 1)) {
        probableRunsList.push(oBet.sessionRuns - 1);
      }
    }
    for (let bet of marketBetslipBets) {
      if (!probableRunsList.includes(bet.oddValue)) {
        probableRunsList.push(bet.oddValue);
      }
      // if (!probableRunsList.includes(bet.oddsPrice - 1)) {
      //   probableRunsList.push(bet.oddsPrice - 1);
      // }
    }
    probableRunsList.sort();

    for (let pr of probableRunsList) {
      let risk = 0;
      for (let oBet of marketOpenBets) {
        const returns = oBet.stakeAmount * oBet.oddValue - oBet.stakeAmount;
        if (oBet.betType === 0) {
          if (pr < oBet.sessionRuns) risk -= returns;
          else risk += returns;
        } else if (oBet.betType === 1) {
          if (pr < oBet.sessionRuns) risk += returns;
          else risk -= returns;
        }
      }
      // for (let bet of marketBetslipBets) {
      //   const returns = bet.amount * ((bet.oddsSize + 100) / 100) - bet.stake;
      //   if (bet.betType === 'BACK') {
      //     if (pr < bet.oddsPrice) risk -= returns;
      //     else risk += returns;
      //   } else if (bet.type === 'LAY') {
      //     if (pr < bet.oddsPrice) risk += returns;
      //     else risk -= returns;
      //   }
      // }
      if (risk < maxRisk) maxRisk = risk;
    }

    return maxRisk >= 0 ? null : maxRisk;
  };

  useEffect(() => {
    fetchData();
    fetchBinaryLimits();
  }, [loggedIn]);

  const handleExchnageBet = (bet: BinaryEvent, isBackBet: boolean) => {
    if (!loggedIn) {
      return;
    }

    // addExchangeBet({
    //   marketId: bet.Market,
    //   oddValue: isBackBet ? bet.BackPrice1 : bet.LayPrice1,
    //   // size: isBackBet ? bet.BackPrice1 : bet.LayPrice1,
    //   betType: isBackBet ? 'BACK' : 'LAY',
    //   amount: 0,
    //   marketName: 'BINARY',
    //   outcomeId: bet.RunnerName,
    //   outcomeDesc: getDisplayName(bet.RunnerName),
    //   marketType: 'BINARY',
    //   sportId: '',
    //   seriesId: '',
    //   seriesName: '',
    //   eventId: '',
    //   eventName: '',
    //   sessionPrice: -1,
    //   eventDate: new Date().getTime(),
    // });
  };

  return (
    <>
      <div className="be-table-ctn">
        <div className="be-table-content table-ctn">
          <TableContainer component={Paper}>
            <Table className="be-table">
              <TableHead>
                <TableRow>
                  <TableCell align="left" className="market-name-cell-head">
                    Categories
                    <IonIcon
                      className="info-img"
                      onClick={() =>
                        setInfoDialog({
                          launch: true,
                          eventTypeID: 'Binary',
                        })
                      }
                      src={InfoImg}
                    />
                  </TableCell>
                  <TableCell
                    align="right"
                    className="odds-cell-head"
                    colSpan={2}
                  >
                    Min:{' '}
                    {betLimits && betLimits.minStake
                      ? betLimits.minStake
                      : '100'}{' '}
                    Max:{' '}
                    {betLimits && betLimits.maxStake
                      ? betLimits.maxStake
                      : '10k'}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow className="header-row">
                  {tableFields.map((tF, index) => (
                    <TableCell
                      key={tF.key + index}
                      align={tF.align === 'left' ? 'left' : 'center'}
                      className={tF.className}
                    >
                      {tF.Label}
                    </TableCell>
                  ))}
                </TableRow>
                {binaryEvents.length > 0 ? (
                  <>
                    {binaryEvents.map((be, index) => (
                      <TableRow>
                        <TableCell className="market-name-cell">
                          {getDisplayName(be.RunnerName)}
                          <span className="risk-value">{getRiskValue(be)}</span>
                        </TableCell>
                        <TableCell className="odds-cell">
                          <div className="odds-block">
                            <ExchOddBtn
                              mainValue={be.LayPrice1}
                              mainValueClass="runs"
                              subValue={100}
                              // disable={true}
                              subValueClass="odds"
                              oddType="odds-no-cell"
                              valueType="binaryOdds"
                              onClick={() => {
                                handleExchnageBet(be, false);
                              }}
                            />
                          </div>
                        </TableCell>
                        <TableCell className="odds-cell">
                          <div className="odds-block">
                            <ExchOddBtn
                              mainValue={be.BackPrice1}
                              mainValueClass="runs"
                              subValue={100}
                              // disable={true}
                              subValueClass="odds"
                              oddType="odds-yes-cell"
                              valueType="binaryOdds"
                              onClick={() => {
                                handleExchnageBet(be, true);
                              }}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </>
                ) : (
                  <TableRow>
                    <TableCell colSpan={3}>
                      <div className="be-table-msg-text">
                        No Binary markets at this moment
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Drawer
                  anchor={'right'}
                  open={infoDilalog.launch}
                  onClose={() =>
                    setInfoDialog({
                      launch: false,
                      oddsType: null,
                      eventTypeID: null,
                    })
                  }
                  className="light-bg-title game-rules-drawer"
                  title="Rules"
                  // size="md"
                >
                  <div className="game-rules-header">
                    <div className="game-rules-title">Game Rules</div>
                    <div className="game-rules-close cursor" onClick={() => setInfoDialog({
                      launch: false,
                      oddsType: null,
                      eventTypeID: null,
                    })}><CloseOutlined /></div>
                    </div>
                    <MarketTermsCondi eventTypeID={infoDilalog.eventTypeID} />
                </Drawer>
          
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
    loggedIn: state.auth.loggedIn,
    binaryOdds: state.exchangeSports.binaryMarkets,
    betFairWSConnected: state.exchangeSports.betFairWSConnected,
  };
};
const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: PlaceBetRequest) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BinaryEventsTable);
